import { ButtonGroup, Flex } from '@chakra-ui/react';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import Card from 'components/card/Card';
import CheckTable from 'components/dataTables/CheckTable';
import { useGlobalContext } from 'contexts/GlobalContext';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import moment from 'moment';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

import { columnsDataStopTypology } from './variables/columnsData';

interface IStopTypology {
	id: number;
	tipologia_parada: string;
	programada: boolean;
	tempo_de_parada: number;
}

export default function CadastroParadas() {
	const history = useHistory();

	const { pathCompanyName } = useGlobalContext();

	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const tableColumns = useMemo(() => columnsDataStopTypology, []);

	const helpTipologiaParadas: ISidebarHelp = useMemo(
		() => ({
			title: 'Paradas',
			firstParagraph:
				'Nesta tela é possível cadastrar e visualizar todas as Paradas Programadas e Não Programadas da sua indústria. A parada programada indica que a produção parou por algum motivo previsto e planejado, por exemplo: refeição ou limpeza. Em contrapartida, uma parada não programada são interrupções imprevistas na linha de produção, por exemplo: falta de matéria prima ou falta de mão de obra.',
			secondParagraph:
				'Acesse o botão “Cadastrar Parada” para adicionar uma nova parada.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	const dataDelete = useMemo(
		() => ({
			provider: 'topology',
			invalidate: 'tipologiaParadas-list',
			toastSuccessTitle: 'Excluida com sucesso!',
			toastSuccessDescription: 'A parada foi excluida com sucesso.',
			toastErrorTitle: 'Erro ao excluir parada!',
			title: 'Deseja realmente excluir esta Parada?',
			text: [
				'Você está prestes a excluir esta parada da sua base de cadastros. Excluir esta parada resultará na remoção dos seguintes itens vinculados a ela:',
				'REPLACE_ME',
				'Você tem certeza que deseja excluir?',
			],
		}),
		[]
	);
	const deleteMessage = useMemo(
		() => [
			'Você está prestes a excluir esta(s) parada(s) da sua base de cadastros. Excluir estas parada(s) resultará na remoção dos seguintes itens vinculados a ela:',
			'REPLACE_ME',
		],
		[]
	);

	const dataDeleteAll = useMemo(
		() => ({
			provider: 'stopTypology',
			toastSuccessTitle: 'Registros excluídos com sucesso!',
			toastSuccessDescription: 'As paradas foram excluídas com sucesso',
			toastErrorTitle: 'Erro ao excluir paradas!',
			invalidate: 'tipologiaParadas-list',
		}),
		[]
	);

	const goToCreateStopTypology = useCallback(() => {
		history.push(
			`/${pathCompanyName}/cadastros/producao/tipologia/cadastrar`
		);
	}, [history, pathCompanyName]);

	const renderRow = useCallback((stopTypology: IStopTypology) => {
		return {
			id: stopTypology?.id,
			tipologiaParada: stopTypology?.tipologia_parada,
			programada: stopTypology?.programada ? 'SIM' : 'NÃO',
			tempoDeParada:
				stopTypology?.tempo_de_parada != null
					? moment
							.utc(
								moment
									.duration(
										stopTypology?.tempo_de_parada,
										'seconds'
									)
									.asMilliseconds()
							)
							.format('HH:mm:ss')
					: '',
		};
	}, []);

	const renderButtons = useCallback(() => {
		return (
			<Flex
				flexDirection={'row'}
				justifyContent={'flex-end'}
				mt={'20px'}
				me={'20px'}
				mb={'40px'}
			>
				<ButtonGroup spacing={'20px'}>
					<ButtonComponent
						data-test={'button-cadastrar-paradas'}
						type={'primary'}
						title={'Cadastrar'}
						onClick={goToCreateStopTypology}
					/>
				</ButtonGroup>
			</Flex>
		);
	}, [goToCreateStopTypology]);

	function renderTable() {
		return (
			<CheckTable
				dataTest='button-filtrar-paradas'
				module={'tipologiaParadas'}
				linkEditForm={`/${pathCompanyName}/cadastros/producao/tipologia/editar`}
				columnsData={tableColumns}
				dataDelete={dataDelete}
				deleteMessage={deleteMessage}
				showGenericSearchInput={false}
				filterModule='tipologiaParadas'
				bulkDeleteProps={dataDeleteAll}
				renderRow={renderRow}
				textHelper='Paradas programadas foram previstas e mapeadas.'
				tableTest='tabela-paradas'
			/>
		);
	}

	useEffect(() => {
		setDataSidebar(helpTipologiaParadas);
	}, [helpTipologiaParadas, setDataSidebar]);

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card pl='0em'>
				{renderButtons()}
				{renderTable()}
			</Card>
		</Flex>
	);
}
